var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"color":"red","content":_vm.unreadNotifications,"offset-y":"24","offset-x":"24"}},[_c('v-btn',{attrs:{"to":{ name: 'user.notifications' },"icon":""}},[_c('v-icon',[_vm._v("mdi-bell")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }